import React from "react";
import CSS from "csstype";

interface IParams {
  text: string;
  font?: string;
  fontSize?: number;
  fontColor?: string;
}

const PodiumTitleComponent: React.FC<IParams> = ({
  text,
  font,
  fontSize,
  fontColor,
}) => {
  const cssStyle: CSS.Properties = {
    fontFamily: font ?? "sans-serif",
    fontSize: fontSize ? `${fontSize * 0.25}vw` : "4vw",
    color: fontColor ?? "#0c0c0c",
  };

  return (
    <div className="text-center" style={cssStyle}>
      {text}
    </div>
  );
};

export default PodiumTitleComponent;
